import { useEffect, useState } from "react";

export function useIsMdScreen() {
  const [isMd, setIsMd] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 768px)"); // Tailwind's "md" breakpoint
    const updateIsMd = () => setIsMd(mediaQuery.matches);

    updateIsMd();
    mediaQuery.addEventListener("change", updateIsMd);

    return () => mediaQuery.removeEventListener("change", updateIsMd);
  }, []);

  return isMd;
}

export function useIsXlScreen() {
  const [isXl, setIsXl] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 1280px)"); // Tailwind's "xl" breakpoint
    const updateIsXl = () => setIsXl(mediaQuery.matches);

    updateIsXl();
    mediaQuery.addEventListener("change", updateIsXl);

    return () => mediaQuery.removeEventListener("change", updateIsXl);
  }, []);

  return isXl;
}
